// extracted by mini-css-extract-plugin
export default {"parent":"ModalFooter_parent__jd6oL","decorationLine":"ModalFooter_decorationLine__nFIpY"};